import { useSearchParams } from 'react-router-dom';
import { Resource } from '../../lib/types';
import { useAppDispatch, useAppSelector } from '../../hooks';
import {
  addToSelected,
  appSelectors,
  deleteFromSelected,
  setCurrentResource,
} from '../../redux/appSlice';

import Card from '../Card';

import { useCallback } from 'react';
import { RootState } from '../../redux/store';

export interface ResourceCardProps {
  resource: Resource;
  onRemoveResource?: (resourceId: number) => void;
}

export const ResourceCard = ({
  resource,
  onRemoveResource,
}: ResourceCardProps) => {
  const [, setSearchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const selected: boolean = useAppSelector((state) =>
    appSelectors.isResourceSelected(state as RootState, resource.ref)
  );

  const handleResourceClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    resourceId: number
  ) => {
    event.preventDefault();
    setSearchParams((currentSearchParams: URLSearchParams): URLSearchParams => {
      currentSearchParams.set('resource', resourceId.toString());
      return currentSearchParams;
    });
    dispatch(setCurrentResource(resource));
  };

  const handleSelectedChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
        dispatch(addToSelected(resource));
      } else {
        dispatch(deleteFromSelected(resource));
      }
    },
    [dispatch, resource]
  );

  return (
    <Card className="Resource">
      <a
        href="#"
        onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) =>
          handleResourceClick(event, resource.ref)
        }
      >
        <Card.Image imageSrc={resource.url_mth} />
      </a>
      <input
        id={`resource-select-${resource.ref}`}
        type="checkbox"
        checked={selected}
        onChange={handleSelectedChange}
      />
      <label htmlFor={`resource-select-${resource.ref}`} />

      {onRemoveResource && (
        <button
          className="resource-delete-button"
          onClick={() => onRemoveResource(resource.ref)}
        />
      )}
    </Card>
  );
};
